import { render } from "./DashboardPageV2.vue?vue&type=template&id=4ebccdd5"
import script from "./DashboardPageV2.vue?vue&type=script&lang=js"
export * from "./DashboardPageV2.vue?vue&type=script&lang=js"

import "./DashboardPageV2.vue?vue&type=style&index=0&id=4ebccdd5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__